<template lang="html">
    <section class="edit-delivery-address">
        <h1>{{ $t("orders.deliveryAddress.TitleModify") }}</h1>
        <div class="edit-delivery-address-textarea">
            <textarea v-model.trim="updateContentAddress" :key="action.data.id" :class="{ empty: error }" rows="7" cols="40"> </textarea>
        </div>
        <div>
            <button class="btn btn-client" @click.prevent="hideModal">{{ $t("actions.cancel") }}</button>
            <button class="btn btn-client" @click.prevent="deliveryAdressModify();">{{ $t("actions.confirm") }}</button>
        </div>
    </section>
</template>

<script lang="js">
import { mapActions} from 'vuex'

export default {
    name: 'edit-delivery-address',
    props: [
        'action'
    ],
    data () {
        return {
            error: false,
            updateContentAddress: ""
        }
    },
    watch: {
    },
    created () {
        this.updateContentAddress = this.action.data.deliveryAddress.content
    },
    methods: {
        ...mapActions("order", {
            addDeliveryAddress: "details/addDeliveryAddress"
        }),
        deliveryAdressModify() {
            if (this.updateContentAddress) {
                let ObjDataDeliveryAddress = {
                    "deliveryAddress" : {
                        "id" : this.action.data.deliveryAddress.id,
                        "content": this.updateContentAddress
                    }
                }
                try {
                    this.error = false
                    this.addDeliveryAddress(ObjDataDeliveryAddress)
                    this.$root.$emit('bv::hide::modal', 'defaultModal')
                }
                catch (e) {
                    console.log(e);
                }
            }else {
                this.error = true
            }
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.error = false
            this.updateContentAddress = this.action.data.deliveryAddress.content
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {
    }
}
</script>
<style lang="scss" scoped>
.edit-delivery-address {
    &-textarea {
        margin-bottom: 20px;
        textarea {
            &.empty {
                border: 1px solid red;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditDeliveryAddress.vue?2ed045d0